<template>
  <!-- Telegram Verification Dialog -->
  <!-- Removed -->

  <div
    :dir="currentDir"
    class="modal fade fp-modal"
    id="forgetpassword-modal"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered fp-dialog">
      <div class="modal-content fp-content">
        <!-- Close Button -->
        <button type="button" class="fp-close-btn" data-bs-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>

        <!-- Icon Header -->
        <div class="fp-icon-header">
          <div class="fp-icon-circle">
            <i class="fas fa-lock"></i>
          </div>
          <div class="fp-step-indicator">
            <span :class="{ active: step === 1 }">1</span>
            <span class="fp-step-line" :class="{ active: step === 2 }"></span>
            <span :class="{ active: step === 2 }">2</span>
          </div>
        </div>

        <div class="fp-body">
          <!-- Title -->
          <h4 class="fp-title">
            {{
              step === 1 ? $t("auth.fp_title_step1") : $t("auth.fp_title_step2")
            }}
          </h4>
          <p class="fp-subtitle">
            {{
              step === 1 ? $t("auth.fp_intro_step1") : $t("auth.fp_intro_step2")
            }}
          </p>

          <!-- Success Message -->
          <div v-if="successMessage" class="fp-success-msg">
            <i class="fas fa-check-circle"></i>
            {{ successMessage }}
          </div>

          <!-- Error Message -->
          <div v-if="errorMessage" class="fp-error-msg">
            <i class="fas fa-exclamation-circle"></i>
            {{ errorMessage }}
          </div>

          <!-- Telegram Verification Section -->
          <div
            v-if="
              step === 1 &&
              selectedMethod === 'telegram' &&
              showTelegramVerification
            "
            class="fp-telegram-section"
          >
            <div class="fp-telegram-icon">
              <i class="fab fa-telegram"></i>
            </div>
            <h6>{{ $t("auth.telegram_verification") }}</h6>
            <p>{{ telegramMessage }}</p>
            <div class="fp-telegram-btns">
              <a
                v-if="botLink"
                :href="botLink"
                target="_blank"
                class="fp-btn fp-btn-telegram"
              >
                <i class="fab fa-telegram"></i> {{ $t("auth.start_chat") }}
              </a>
              <button
                class="fp-btn fp-btn-primary"
                @click="checkTelegramVerification"
                :disabled="isLoading"
              >
                <i class="fas fa-check-circle"></i>
                {{
                  isLoading
                    ? $t("common.verifying")
                    : $t("auth.completed_verification")
                }}
              </button>
            </div>
          </div>

          <!-- Step 1: Phone Input -->
          <div v-if="step === 1" class="fp-form">
            <div class="fp-input-group">
              <label
                ><i class="fas fa-phone"></i>
                {{ $t("auth.fp_phone_label") }}</label
              >
              <input id="phoneOtp" type="tel" class="fp-input" dir="ltr" />
            </div>

            <!-- Send Method Selection -->
            <div class="fp-methods">
              <label class="fp-methods-label"
                ><i class="fas fa-paper-plane"></i>
                {{ $t("auth.fp_send_method_label") }}</label
              >
              <div class="fp-methods-grid">
                <label
                  class="fp-method-card"
                  :class="{ selected: selectedMethod === 'sms' }"
                >
                  <input type="radio" value="sms" v-model="selectedMethod" />
                  <div class="fp-method-icon sms">
                    <i class="fas fa-sms"></i>
                  </div>
                  <span>{{ $t("auth.fp_method_sms") }}</span>
                </label>
                <label
                  class="fp-method-card"
                  :class="{ selected: selectedMethod === 'email' }"
                >
                  <input type="radio" value="email" v-model="selectedMethod" />
                  <div class="fp-method-icon email">
                    <i class="fas fa-envelope"></i>
                  </div>
                  <span>{{ $t("auth.fp_method_email") }}</span>
                </label>
                <label
                  class="fp-method-card"
                  :class="{ selected: selectedMethod === 'telegram' }"
                >
                  <input
                    type="radio"
                    value="telegram"
                    v-model="selectedMethod"
                  />
                  <div class="fp-method-icon telegram">
                    <i class="fab fa-telegram"></i>
                  </div>
                  <span>{{ $t("auth.fp_method_telegram") }}</span>
                </label>
              </div>
            </div>

            <button
              class="fp-btn fp-btn-primary fp-btn-full"
              :disabled="isLoading"
              @click="sendPhone"
              v-if="
                !(selectedMethod === 'telegram' && showTelegramVerification)
              "
            >
              <template v-if="isLoading">
                <span class="fp-spinner"></span> {{ $t("auth.fp_sending") }}
              </template>
              <template v-else-if="selectedMethod === 'telegram'">
                <i class="fab fa-telegram"></i>
                {{ $t("auth.verify_with_telegram") }}
              </template>
              <template v-else>
                <i class="fas fa-paper-plane"></i> {{ $t("auth.fp_send_code") }}
              </template>
            </button>
          </div>

          <!-- Step 2: OTP & New Password -->
          <div v-else class="fp-form">
            <div class="fp-input-group">
              <label
                ><i class="fas fa-key"></i> {{ $t("auth.fp_otp_label") }}</label
              >
              <input
                v-model="otp"
                type="text"
                class="fp-input"
                :placeholder="$t('auth.fp_otp_placeholder')"
              />
            </div>

            <div class="fp-input-group">
              <label
                ><i class="fas fa-lock"></i>
                {{ $t("auth.fp_new_password_label") }}</label
              >
              <input
                v-model="newPassword"
                type="password"
                class="fp-input"
                :placeholder="$t('auth.fp_new_password_placeholder')"
              />
            </div>

            <div class="fp-input-group">
              <label
                ><i class="fas fa-lock"></i>
                {{ $t("auth.fp_confirm_password_label") }}</label
              >
              <input
                v-model="confirmPassword"
                type="password"
                class="fp-input"
                :placeholder="$t('auth.fp_confirm_password_placeholder')"
              />
            </div>

            <div class="fp-btn-group">
              <button
                class="fp-btn fp-btn-secondary"
                :disabled="isLoading"
                @click="goBack"
              >
                <i class="fas fa-arrow-right"></i> {{ $t("common.back") }}
              </button>
              <button
                class="fp-btn fp-btn-primary"
                :disabled="isLoading"
                @click="resetPassword"
              >
                <template v-if="isLoading">
                  <span class="fp-spinner"></span>
                </template>
                <template v-else>
                  <i class="fas fa-check"></i>
                  {{ $t("auth.fp_update_password") }}
                </template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";
import i18n from "@/plugins/i18n";
var iti2;

export default {
  computed: {
    currentDir() {
      return this.$i18n && this.$i18n.locale === "ar" ? "rtl" : "ltr";
    },
  },
  data() {
    return {
      step: 1,
      otp: "",
      newPassword: "",
      confirmPassword: "",
      isLoading: false,
      errorMessage: "",
      successMessage: "",
      selectedMethod: "sms",
      showTelegramDialog: false,
      telegramMessage: "",
      botLink: "",
    };
  },
  mounted() {
    const modal = document.getElementById("forgetpassword-modal");
    const phone = document.getElementById("phoneOtp");

    modal.addEventListener("shown.bs.modal", () => {
      iti2 = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly",
        separateDialCode: true,
        excludeCountries: ["il"],
        customPlaceholder: function (
          selectedCountryPlaceholder,
          selectedCountryData
        ) {
          // Remove leading 0 from placeholder (e.g., 0922345678 -> 922345678)
          return selectedCountryPlaceholder.replace(/^0/, "");
        },
      });
    });
  },
  methods: {
    goBack() {
      this.errorMessage = "";
      this.successMessage = "";
      this.step = 1;
      this.selectedMethod = "sms";
      this.$nextTick(() => {
        const phone = document.getElementById("phoneOtp");
        iti2 = intlTelInput(phone, {
          utilsScript: "assets/js/utils.js",
          initialCountry: "ly",
          separateDialCode: true,
          excludeCountries: ["il"],
          customPlaceholder: function (
            selectedCountryPlaceholder,
            selectedCountryData
          ) {
            // Remove leading 0 from placeholder (e.g., 0922345678 -> 922345678)
            return selectedCountryPlaceholder.replace(/^0/, "");
          },
        });
      });
    },

    async checkTelegramVerification() {
      const phoneNumber = iti2.getNumber();
      if (!phoneNumber || phoneNumber.trim() === "") {
        this.errorMessage = i18n.global.t("auth.error_phone_required");
        return;
      }

      try {
        this.isLoading = true;

        const response = await this.sendTelegramRequest(phoneNumber);

        if (response.data.bot_link === null) {
          // User has linked Telegram, proceed to OTP
          this.showTelegramVerification = false;
          this.successMessage = i18n.global.t("auth.telegram_linked_success");
          this.step = 2;
        } else {
          // Show success message with the bot link
          await Swal.fire({
            title: i18n.global.t("auth.telegram_verification"),
            text: response.data.message,
            icon: "info",
            confirmButtonText: i18n.global.t("common.ok"),
            confirmButtonColor: "#198754",
            showCancelButton: true,
            cancelButtonText: i18n.global.t("common.cancel"),
            cancelButtonColor: "#6c757d",
          });

          // Update the verification message and bot link
          this.telegramMessage = response.data.message;
          this.botLink = response.data.bot_link;
        }
      } catch (error) {
        this.errorMessage =
          error.message || i18n.global.t("auth.verification_error");
        this.showTelegramDialog = false;
      } finally {
        this.isLoading = false;
      }
    },

    async sendTelegramRequest(phoneNumber) {
      const payload = {
        phone: phoneNumber,
        country_code: "+" + iti2.getSelectedCountryData().dialCode,
        telegram: "1",
      };

      const res = await fetch(`${apiUrl}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.message || i18n.global.t("auth.fp_send_error"));
      }

      return await res.json();
    },

    async sendPhone() {
      this.errorMessage = "";
      this.successMessage = "";

      // Validate phone number is not empty
      const phoneNumber = iti2.getNumber();
      if (!phoneNumber || phoneNumber.trim() === "") {
        this.errorMessage = i18n.global.t("auth.error_phone_required");
        return;
      }

      if (this.selectedMethod === "telegram") {
        try {
          this.isLoading = true;
          const phoneNumber = iti2.getNumber();
          const response = await this.sendTelegramRequest(phoneNumber);

          this.telegramMessage = response.data.message;
          this.botLink = response.data.bot_link;

          if (response.data.bot_link === null) {
            // User already has Telegram linked, proceed to OTP
            this.successMessage = i18n.global.t("auth.telegram_linked_success");
            this.step = 2;
          } else {
            // Show Telegram verification section
            this.showTelegramVerification = true;
          }
        } catch (error) {
          this.errorMessage =
            error.message || i18n.global.t("auth.fp_send_error");
        } finally {
          this.isLoading = false;
        }
        return;
      }

      // Original flow for other methods (SMS, WhatsApp, Email)
      try {
        this.isLoading = true;
        const phoneNumber = iti2.getNumber();

        const payload = {
          phone: phoneNumber,
          country_code: "+" + iti2.getSelectedCountryData().dialCode,
          sms: this.selectedMethod === "sms" ? 1 : 0,
          whatsapp: this.selectedMethod === "whatsapp" ? 1 : 0,
          email: this.selectedMethod === "email" ? 1 : 0,
        };

        const res = await fetch(`${apiUrl}/forgot-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(
            errData.message || i18n.global.t("auth.fp_send_error")
          );
        }

        this.successMessage = i18n.global.t("auth.fp_sent_success");
        this.step = 2;
      } catch (err) {
        this.errorMessage = err.message || i18n.global.t("auth.fp_send_error");
      } finally {
        this.isLoading = false;
      }
    },

    async resetPassword() {
      this.errorMessage = "";
      if (!this.otp) {
        this.errorMessage = i18n.global.t("auth.fp_required_otp");
        return;
      }
      if (!this.newPassword || this.newPassword.length < 6) {
        this.errorMessage = i18n.global.t("auth.fp_password_min");
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.errorMessage = i18n.global.t("auth.fp_password_mismatch");
        return;
      }

      this.isLoading = true;
      try {
        const res = await fetch(`${apiUrl}/reset-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            otp: this.otp,
            new_password: this.newPassword,
          }),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(
            errData.message || i18n.global.t("auth.fp_update_error")
          );
        }

        Swal.fire(
          i18n.global.t("auth.fp_update_success_title"),
          i18n.global.t("auth.fp_update_success_text"),
          "success"
        );
        this.step = 1;
        this.otp = this.newPassword = this.confirmPassword = "";
      } catch (err) {
        this.errorMessage =
          err.message || i18n.global.t("auth.fp_update_error");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* ========== Animations ========== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes iconBounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* ========== Modal Dialog ========== */
.fp-modal .fp-dialog {
  max-width: 420px;
}

.fp-content {
  border-radius: 24px !important;
  border: none !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
  overflow: visible;
  background: #fff;
  animation: fadeIn 0.3s ease;
  position: relative;
  padding: 0 !important;
}

/* ========== Close Button ========== */
.fp-close-btn {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.fp-close-btn i {
  color: #6b7280;
  font-size: 14px;
}

.fp-close-btn:hover {
  background: #ef4444;
  transform: rotate(90deg);
}

.fp-close-btn:hover i {
  color: #fff;
}

/* ========== Icon Header ========== */
.fp-icon-header {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  padding: 30px 20px 25px;
  text-align: center;
  border-radius: 24px 24px 0 0;
  position: relative;
}

.fp-icon-circle {
  width: 70px;
  height: 70px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  animation: iconBounce 2s ease-in-out infinite;
}

.fp-icon-circle i {
  font-size: 28px;
  color: #00c444;
}

/* Step Indicator */
.fp-step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.fp-step-indicator span:not(.fp-step-line) {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.fp-step-indicator span.active {
  background: #fff;
  color: #00c444;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.fp-step-line {
  width: 40px !important;
  height: 3px !important;
  background: rgba(255, 255, 255, 0.3) !important;
  border-radius: 2px !important;
}

.fp-step-line.active {
  background: #fff !important;
}

/* ========== Body ========== */
.fp-body {
  padding: 25px;
}

.fp-title {
  text-align: center;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 8px;
}

.fp-subtitle {
  text-align: center;
  color: #6b7280;
  font-size: 0.9rem;
  margin: 0 0 20px;
  line-height: 1.5;
}

/* ========== Messages ========== */
.fp-success-msg,
.fp-error-msg {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 16px;
  animation: slideUp 0.3s ease;
}

.fp-success-msg {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  color: #047857;
  border: 1px solid #a7f3d0;
}

.fp-error-msg {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  border: 1px solid #fecaca;
}

.fp-success-msg i,
.fp-error-msg i {
  font-size: 1.1rem;
}

/* ========== Form ========== */
.fp-form {
  animation: slideUp 0.3s ease;
}

.fp-input-group {
  margin-bottom: 16px;
}

.fp-input-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.fp-input-group label i {
  color: #00c444;
  font-size: 0.9rem;
}

.fp-input {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.fp-input:focus {
  outline: none;
  border-color: #00c444;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.1);
}

/* ========== Methods Selection ========== */
.fp-methods {
  margin-bottom: 20px;
}

.fp-methods-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.fp-methods-label i {
  color: #00c444;
}

.fp-methods-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.fp-method-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 10px;
  border: 2px solid #e5e7eb;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.fp-method-card input {
  display: none;
}

.fp-method-card:hover {
  border-color: #a7f3d0;
  background: #f0fdf4;
}

.fp-method-card.selected {
  border-color: #00c444;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.15);
}

.fp-method-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.fp-method-icon.sms {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #d97706;
}

.fp-method-icon.email {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
}

.fp-method-icon.telegram {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  color: #0ea5e9;
}

.fp-method-card.selected .fp-method-icon {
  transform: scale(1.1);
}

.fp-method-card span {
  font-size: 0.8rem;
  font-weight: 600;
  color: #4b5563;
}

.fp-method-card.selected span {
  color: #047857;
}

/* ========== Buttons ========== */
.fp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.fp-btn-primary {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.3);
}

.fp-btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.4);
}

.fp-btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.fp-btn-secondary {
  background: #f3f4f6;
  color: #374151;
  border: 2px solid #e5e7eb;
}

.fp-btn-secondary:hover {
  background: #e5e7eb;
}

.fp-btn-telegram {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(14, 165, 233, 0.3);
}

.fp-btn-telegram:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(14, 165, 233, 0.4);
}

.fp-btn-full {
  width: 100%;
}

.fp-btn-group {
  display: flex;
  gap: 12px;
}

.fp-btn-group .fp-btn {
  flex: 1;
}

/* Spinner */
.fp-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* ========== Telegram Section ========== */
.fp-telegram-section {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 2px solid #bae6fd;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  margin-bottom: 16px;
}

.fp-telegram-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.fp-telegram-icon i {
  font-size: 1.5rem;
  color: #fff;
}

.fp-telegram-section h6 {
  color: #0369a1;
  font-weight: 700;
  margin: 0 0 8px;
}

.fp-telegram-section p {
  color: #64748b;
  font-size: 0.85rem;
  margin: 0 0 16px;
}

.fp-telegram-btns {
  display: flex;
  gap: 10px;
}

.fp-telegram-btns .fp-btn {
  flex: 1;
  padding: 12px 16px;
  font-size: 0.85rem;
}

/* ========== intl-tel-input ========== */
:deep(.iti) {
  width: 100%;
}

:deep(.iti__selected-flag) {
  border-radius: 10px 0 0 10px;
  padding: 0 10px;
  background: #f3f4f6;
}

:deep(.iti--separate-dial-code .iti__selected-flag) {
  background: #f3f4f6;
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] .fp-content,
[data-theme="dark"] .fp-content,
.dark .fp-content {
  background: #1f2937;
}

[data-bs-theme="dark"] .fp-close-btn,
[data-theme="dark"] .fp-close-btn,
.dark .fp-close-btn {
  background: #374151;
}

[data-bs-theme="dark"] .fp-close-btn i,
[data-theme="dark"] .fp-close-btn i,
.dark .fp-close-btn i {
  color: #9ca3af;
}

[data-bs-theme="dark"] .fp-icon-circle,
[data-theme="dark"] .fp-icon-circle,
.dark .fp-icon-circle {
  background: #374151;
}

[data-bs-theme="dark"] .fp-icon-circle i,
[data-theme="dark"] .fp-icon-circle i,
.dark .fp-icon-circle i {
  color: #00e050;
}

[data-bs-theme="dark"] .fp-title,
[data-theme="dark"] .fp-title,
.dark .fp-title {
  color: #f3f4f6;
}

[data-bs-theme="dark"] .fp-subtitle,
[data-theme="dark"] .fp-subtitle,
.dark .fp-subtitle {
  color: #9ca3af;
}

[data-bs-theme="dark"] .fp-input-group label,
[data-theme="dark"] .fp-input-group label,
.dark .fp-input-group label {
  color: #e5e7eb;
}

[data-bs-theme="dark"] .fp-input,
[data-theme="dark"] .fp-input,
.dark .fp-input {
  background: #374151;
  border-color: #4b5563;
  color: #f3f4f6;
}

[data-bs-theme="dark"] .fp-input:focus,
[data-theme="dark"] .fp-input:focus,
.dark .fp-input:focus {
  background: #374151;
  border-color: #00c444;
}

[data-bs-theme="dark"] .fp-methods-label,
[data-theme="dark"] .fp-methods-label,
.dark .fp-methods-label {
  color: #e5e7eb;
}

[data-bs-theme="dark"] .fp-method-card,
[data-theme="dark"] .fp-method-card,
.dark .fp-method-card {
  background: #374151;
  border-color: #4b5563;
}

[data-bs-theme="dark"] .fp-method-card:hover,
[data-theme="dark"] .fp-method-card:hover,
.dark .fp-method-card:hover {
  border-color: #00c444;
  background: #3f4a5a;
}

[data-bs-theme="dark"] .fp-method-card.selected,
[data-theme="dark"] .fp-method-card.selected,
.dark .fp-method-card.selected {
  background: linear-gradient(135deg, #1a3d2a 0%, #1e4d35 100%);
  border-color: #00c444;
}

[data-bs-theme="dark"] .fp-method-card span,
[data-theme="dark"] .fp-method-card span,
.dark .fp-method-card span {
  color: #d1d5db;
}

[data-bs-theme="dark"] .fp-btn-secondary,
[data-theme="dark"] .fp-btn-secondary,
.dark .fp-btn-secondary {
  background: #374151;
  border-color: #4b5563;
  color: #e5e7eb;
}

[data-bs-theme="dark"] .fp-telegram-section,
[data-theme="dark"] .fp-telegram-section,
.dark .fp-telegram-section {
  background: linear-gradient(135deg, #1e3a5f 0%, #1e3a4f 100%);
  border-color: #2563eb;
}

[data-bs-theme="dark"] .fp-telegram-section h6,
[data-theme="dark"] .fp-telegram-section h6,
.dark .fp-telegram-section h6 {
  color: #7dd3fc;
}

[data-bs-theme="dark"] .fp-telegram-section p,
[data-theme="dark"] .fp-telegram-section p,
.dark .fp-telegram-section p {
  color: #94a3b8;
}

[data-bs-theme="dark"] :deep(.iti__selected-flag),
[data-theme="dark"] :deep(.iti__selected-flag),
.dark :deep(.iti__selected-flag) {
  background: #374151;
}

[data-bs-theme="dark"] :deep(.iti__country-list),
[data-theme="dark"] :deep(.iti__country-list),
.dark :deep(.iti__country-list) {
  background: #1f2937;
  border-color: #374151;
}

[data-bs-theme="dark"] :deep(.iti__country:hover),
[data-theme="dark"] :deep(.iti__country:hover),
.dark :deep(.iti__country:hover) {
  background: #374151;
}

/* ========== Responsive ========== */
@media (max-width: 480px) {
  .fp-modal .fp-dialog {
    max-width: 100%;
    margin: 0.5rem;
  }

  .fp-methods-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .fp-method-card {
    padding: 12px 6px;
  }

  .fp-method-icon {
    width: 38px;
    height: 38px;
    font-size: 1rem;
  }

  .fp-method-card span {
    font-size: 0.7rem;
  }

  .fp-btn-group {
    flex-direction: column;
  }

  .fp-telegram-btns {
    flex-direction: column;
  }
}
</style>
